import { I18n } from '@app/i18n/strings-keys';
import { COMMON_ACTION_BUTTONS } from '../../common';
import { BASIC_ACTION_BUTTON } from '../../common/common-actions';

export enum TRANSFER_ACTION_NAMES {
  Cancel = 'Cancel Transfer',
  PrintWrittenSheet = 'Print Written Sheet',
  SaveAsTemplate = 'Save as a Template',
}

export enum TRANSFER_ACTION_TYPES {
  PrintWrittenSheet = 'print_written_sheet',
  SaveAsTemplate = 'save_as_template',
}

export const TRANSFER_ACTION_BUTTONS = [
  {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Forms.TransferForm.SaveasaTemplate,
    type: TRANSFER_ACTION_TYPES.SaveAsTemplate,
    permissionCodes: [
      'VenuesInventory.TransferGroupTemplate.View',
      'VenuesInventory.TransferGroupTemplate.Add',
    ],
  },
  COMMON_ACTION_BUTTONS.View,
  {
    ...COMMON_ACTION_BUTTONS.Edit,
    permissionCodes: ['VenuesInventory.Transfer.Manage'],
  },
  {
    ...COMMON_ACTION_BUTTONS.Accept,
    permissionCodes: ['VenuesInventory.Transfer.Manage'],
  },
  {
    ...COMMON_ACTION_BUTTONS.Reject,
    permissionCodes: ['VenuesInventory.Transfer.Manage'],
  },
  {
    ...COMMON_ACTION_BUTTONS.Submit,
    permissionCodes: ['VenuesInventory.Transfer.Manage'],
  },
  {
    ...COMMON_ACTION_BUTTONS.Cancel,
    name: I18n.Forms.TransferForm.CancelTransfer,
    permissionCodes: ['VenuesInventory.Transfer.Manage'],
  },
  {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.PrintWrittenSheet,
    type: TRANSFER_ACTION_TYPES.PrintWrittenSheet,
  },
  COMMON_ACTION_BUTTONS.Print,
  COMMON_ACTION_BUTTONS.Export,
  {
    ...COMMON_ACTION_BUTTONS.Void,
    permissionCodes: [
      'VenuesInventory.Transfer.Manage',
      'VenuesInventory.Transfer.Void',
    ],
  },
  {
    ...COMMON_ACTION_BUTTONS.Duplicate,
    permissionCodes: ['VenuesInventory.Transfer.Add'],
  },
];
